import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceAtMalleoli extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - At Malleoli' />
                <label className={styles.label}>At Malleoli</label>
                <span className={styles.circum_column}>
                    <DBDecimalFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOCIRMALLEOLIR'
                        className={styles.circum_input}
                        min={0}
                    />
                    <label>&nbsp;&nbsp;cm</label>
                </span>
                <span className={styles.circum_column}>
                    <DBDecimalFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOCIRMALLEOLIL'
                        className={styles.circum_input}
                        min={0}
                    />
                    <label>&nbsp;&nbsp;cm</label>
                </span>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMALLEOLIR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMALLEOLIR !== null)
            || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMALLEOLIL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRMALLEOLIL !== null)
            ? true : false
    };
}

const connectedObservationCircumferenceAtMalleoli = connect(mapStateToProps)(ObservationCircumferenceAtMalleoli);
export { connectedObservationCircumferenceAtMalleoli as ObservationCircumferenceAtMalleoli };


